import React, { useEffect, useState } from 'react';
import { formatDateParsedZoneLong } from 'platform/utilities/date/index';
import { lastFour } from '../utilities/helpers';

const ClaimantSearchNoPOA = searchData => {
  const [resultsSummary, setResultsSummary] = useState('');

  useEffect(() => {
    setTimeout(
      () =>
        setResultsSummary(
          <>
            No result found for <strong>"{searchData.first_name}"</strong>
            {', '}
            <strong>"{searchData.last_name}"</strong>
            {', '}
            <strong>"{formatDateParsedZoneLong(searchData.dob)}"</strong>
            {', '}
            <strong>
              "***-**-
              {lastFour(searchData.ssn)}"
            </strong>
            . Check the entered information and try the search again.
          </>,
        ),
      150,
    );
  }, []);

  return (
    <>
      <hr className="divider claimant-search" aria-hidden="true" />
      <p
        data-testid="representation-requests-table-fetcher-no-poa-requests"
        className="claimant__results-text"
        role="status"
      >
        {resultsSummary}
      </p>

      <va-alert status="info" class="claimant__banner" visible>
        <h2 slot="headline" className="vads-u-margin-y--0">
          You don’t represent this claimant
        </h2>

        <p>
          This claimant may be in our system, but you can’t access their
          information or act on their behalf until you establish representation.
        </p>

        <a href="/representative/help#establishing-representation">
          Learn about establishing representation
        </a>
      </va-alert>

      <va-additional-info
        class="claimant__additional-info"
        trigger="The portal doesn’t check for limited representation"
      >
        <p>
          Limited representation means that the representation is only for a
          specific claim or claims. Check with the claimant or in VBMS for any
          existing limited representation.
        </p>
      </va-additional-info>
    </>
  );
};

export default ClaimantSearchNoPOA;
